import React, { createContext, useState, useEffect } from "react";

import RouteConstants from "../../../constants/routeConstants.json";
import { useNavigate, useLocation } from "react-router";
import ContentData from "../../../constants/contentFile.json";
import { spaceCheck, validateRoleName } from "../../../utils/service";
import { addRoleApi, getrolenFeatureApi } from "../../../api/Api";
import { useCookies } from "react-cookie";
import { handleApiError } from "../../../constants/Constants";
export const RoleAddContext = createContext({});

export const RoleAddContextProvider = ({ children }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [validatedName, setValidatedName] = useState("");
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [userPermissionList, setUserPermissionList] = useState([]);
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);

  // description validation
  const [validateDescription, setValidatedDescription] = useState("");
  const navigator = useNavigate();

  useEffect(() => {
    dataUserPermissionList();
  }, []);

  const rolesList = () => {
    navigator(RouteConstants.ROLE_LIST);
  };
  // name validation
  const nameValidation = (value) => {
    if (value === "") {
      setValidatedName(ContentData.rolePermissions.enterRole);
      return false;
    } else if (spaceCheck(value)) {
      setValidatedName(ContentData.rolePermissions.nameSpaceCheckMessage);
      return false;
    } else {
      setValidatedName("");
      return true;
    }
  };

  // description  white space check
  const descriptionCheck = (value) => {
    if (value === "") {
      setValidatedDescription(ContentData.rolePermissions.descriptionMessage);
      return false;
    } else if (spaceCheck(value)) {
      setValidatedDescription(
        ContentData.rolePermissions.descriptionSpaceCheckMsg
      );
      return false;
    } else {
      setValidatedDescription("");
      return true;
    }
  };

  const handleRoleName = (e) => {
    e.preventDefault();
    const roleValue = e.target.value;
    const capitalizedValue =
      roleValue.charAt(0).toUpperCase() + roleValue.slice(1);

    if (validateRoleName(capitalizedValue)) {
      setName(capitalizedValue);
    } else if (roleValue === "") {
      setName("");
    }
  };

  const handleDescription = (e) => {
    e.preventDefault();
    const descriptionValue = e.target.value;
    if (descriptionValue.startsWith(" ")) {
      return;
    }
    setDescription(e.target.value);

    //descriptionCheck(e.target.value);
  };

  const dataUserPermissionList = async () => {
    try {
      setSpinnerStatus(true);
      const data = await getrolenFeatureApi();
      if (data?.data?.statusCode === 200) {
        setSpinnerStatus(false);
        const permisssionUpdated = data?.data?.data?.map((item) => {
          return {
            ...item,
            view: false,
            add: false,
            edit: false,
            delete: false,
          };
        });
        setUserPermissionList(permisssionUpdated);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const newPermissionCategory = (id, key, value) => {
    const updatedData = userPermissionList?.map((item) => {
      if (item._id === id) {
        if (key === "view") {
          // If the "view" key is toggled, update only the "view" property
          return {
            ...item,
            [key]: !value,
          };
        } else {
          // For other keys, toggle the key, and set "view" to true only if it's not currently false
          return {
            ...item,
            [key]: !value,
            view: item.view || !value, // Ensure "view" stays true unless explicitly toggled off
          };
        }
      }
      return item;
    });

    setUserPermissionList(updatedData);

    return updatedData;
  };

  const roleToLogin = () => {
    navigator(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const modifyUserPermissionList = userPermissionList.map(
    ({ _id, edit, delete: any, add, view }) => ({
      feature: _id,
      edit,
      delete: any,
      add,
      view,
    })
  );

  const addRoleformValidation = async (e) => {
    e.preventDefault();

    // Validation: Check if all permissions are false for all features
    const allPermissionsFalse = modifyUserPermissionList.every(
      (item) => !item.edit && !item.delete && !item.add && !item.view
    );

    // If all permissions are false, set permissions to an empty array
    const permissions = allPermissionsFalse ? [] : modifyUserPermissionList;

    const roleDetails = {
      name: name,
      description: description?.trim(),
      permissions: permissions,
    };
    const nameValidate = nameValidation(name);
    const descriptionValidate = descriptionCheck(description);

    if (nameValidate && descriptionValidate) {
      try {
        setSpinnerStatus(true);
        const getData = await addRoleApi(roleDetails);
        if (getData?.status === 200) {
          setSpinnerStatus(false);
          setSuccessAlertShow(true);
          setErrorPopup(false);
          setSuccessAlertMessage(
            getData?.data?.message
              ? getData?.data?.message
              : "Role created successfully"
          );
        }
      } catch (error) {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText
        );
      }
      setSpinnerStatus(false);
    }
  };

  const providerValue = {
    name,
    handleRoleName,
    validatedName,
    addRoleformValidation,
    userPermissionList,
    description,
    spinnerStatus,
    rolesList,
    handleDescription,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    roleToLogin,
    buttonText,
    newPermissionCategory,
    statusValue,
    spinnerStatus,
    successAlertMessage,
    successAlertShow,
    nameValidation,

    validateDescription, // description white space check
  };
  return (
    <RoleAddContext.Provider value={providerValue}>
      {children}
    </RoleAddContext.Provider>
  );
};
